import {
  IHttpApi,
  mergeBaseUri,
  mergePaths,
  transformObjectToQuery,
  IHTTPRequestConfig,
  IHTTPCompletedResponse,
} from '@cian/http-api';

import { IEditCommentRequest, IEditCommentConfig, TResponses } from './types';

const defaultConfig: Required<IEditCommentConfig> = {
  pathApi: '/v1/edit-comment',
  browserUrl: 'http://www.master.dev3.cian.ru/content-api',
};

export const defaultRequest: IHTTPRequestConfig = {
  uri: {
    host: '',
    path: '',
  },
  method: 'POST',
  requestType: 'formData',
  body: '',
  withCredentials: true,
  responseType: 'json',
  headers: [['Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8']],
};

function createEditCommentRequest({
  bodyParameters,
  queryParameters,
  config,
}: Pick<IEditCommentOptions, 'bodyParameters' | 'queryParameters' | 'config'>): IHTTPRequestConfig {
  const { pathApi, browserUrl } = { ...defaultConfig, ...config };

  return {
    ...defaultRequest,
    uri: mergeBaseUri(browserUrl, {
      path: (path: string) => mergePaths(path, pathApi),
      query: transformObjectToQuery(queryParameters),
    }),
    body: transformObjectToQuery(bodyParameters),
  };
}

export interface IEditCommentOptions {
  httpApi: IHttpApi;
  bodyParameters: IEditCommentRequest;
  queryParameters?: IEditCommentRequest;
  config?: IEditCommentConfig;
}

async function requestEditComment({
  httpApi,
  bodyParameters,
  queryParameters,
  config,
}: IEditCommentOptions): Promise<IHTTPCompletedResponse<TResponses>> {
  return httpApi.httpRequest(createEditCommentRequest({ bodyParameters, queryParameters, config }));
}

export { defaultConfig, createEditCommentRequest, requestEditComment };
